<template>
  <div class="courseware-box">
    <RecycleScroller
      class="scroller"
      :items="coursewares"
      :item-size="400"
      key-field="id"
      v-slot="{ item, index }"
    >
      <div class="courseware-item">
        <div class="top-line">
          <p>{{item.title}}</p>
          <div class="btns" v-if="isEdit">
            <span v-if="index!==0" @click="moveUp(item, index)">上移</span>
            <span v-if="index+1<coursewares.length" @click="moveDown(item, index)">下移</span>
            <span class="edit" @click="handleEdit(item.id)">修改</span>
          </div>
        </div>
        <div class="iframe-box">
          <!-- 统一走 Iframe 组件：.pdf 用 iframe，.pptx 用 @vue-office/pptx 纯前端渲染，.ppt/其他走下载兜底；不再依赖 officeapps（内网文件无法访问） -->
          <iframe-file :src="coursewareUrl[item.filePath]" />
        </div>
      </div>
    </RecycleScroller>
  </div>
</template>

<script>
import { packgeServer } from '@/api/api'
import { RecycleScroller } from 'vue-virtual-scroller'
import iframeFile from '@/components/Iframe'
export default {
  props: {
    coursewares: {
      type: Array,
      require: false
    },
    coursewareUrl: {
      type: Object,
      require: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {RecycleScroller, iframeFile},
  methods: {
    moveUp (item, index) {
      const json = [
        {id: item.id, sort: this.coursewares[index - 1].sort === item.sort ? this.coursewares[index - 1].sort + 5 : this.coursewares[index - 1].sort},
        {id: this.coursewares[index - 1].id, sort: item.sort}
      ]
      packgeServer.coursewareSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    moveDown (item, index) {
      const json = [
        {id: item.id, sort: this.coursewares[index + 1].sort === item.sort ? this.coursewares[index + 1].sort - 5 : this.coursewares[index + 1].sort},
        {id: this.coursewares[index + 1].id, sort: item.sort}
      ]
      packgeServer.coursewareSort(JSON.stringify(json)).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update')
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    handleEdit (id) {
      let rourteUrl = this.$router.resolve({
        path: '/resource/addcourseIndex',
        query: {id}
      });
      window.open(rourteUrl.href, '_blank')
    },
  }
}
</script>

<style scoped lang='scss'>
.courseware-box {
  margin-top: 10px;
  line-height: 30px;
  .courseware-item {
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .top-line {
    position: relative;
    text-align: left;
    p {
      display: inline-block;
      width: calc(100% - 125px);
      font-size: 16px;
      font-weight: 600;
    }
    .btns {
      display: inline-block;
      position: absolute;
      right: 0;
      span {
        padding: 0 5px;
        color: #409eff;
        cursor: pointer;
      }
      .edit {
        color: #95d1a3;
      }
    }
  }
}
.iframe-box {
  min-height: 350px;
  height: 350px;
  iframe-file {
    display: block;
    width: 100%;
    height: 100%;
  }
  ::v-deep .body {
    height: 100%;
  }
}
.scroller {
  height: 800px; /* 滚动区域高度，根据实际调整 */
}
</style>


// WEBPACK FOOTER //
// src/views/coursePackage/components/courseware.vue